import React, { useEffect } from "react";

import JupyterNotebookComp from "./JupyterNotebookComp";

const RunNotebook = (props) => {
    const { rawIpynb1, reRenderNotebook = () => { } } = props;
    const [rawIpynb, setRawIpynb] = React.useState(rawIpynb1);
    const controller1 = new AbortController();

    const initializeCellExecutionDetailsArray = (rawIpynb) => {
        if (!rawIpynb || !rawIpynb.cells) { return []; }
        return rawIpynb.cells.map(() => {
            return { isExecuting: false, startTime: null, executionCount: 0 };
        });
    };
    const [cellExecutionDetails, setCellExecutionDetails] = React.useState(initializeCellExecutionDetailsArray(rawIpynb));
    const [RunCodequeue, setRunCodequeue] = React.useState([]);
    const [processing, setProcessing] = React.useState(false);
    const [executionCount, setExecutionCount] = React.useState(1);

    // const [output, setOutput] = React.useState([{ "name": "stdout", "output_type": "stream", "text": [] }])
    const [interruptSignalState, setInterruptSignalState] = React.useState(false);
    const setResponseData = (cellIndex, output) => {
        // console.log("setting data, ", output);
        setRawIpynb(prevRawIpynb => {
            const temp_ipynb = { ...prevRawIpynb };
            if (temp_ipynb.cells && temp_ipynb.cells[cellIndex]) {
                temp_ipynb.cells[cellIndex] = {
                    ...temp_ipynb.cells[cellIndex],
                    outputs: output,
                };
            }
            return temp_ipynb;
        });

    }
    const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };
    const InterruptCodeExecution = async () => {
        try {
            const response = await fetch('https://workable-ai-ml-2.onrender.com/interrupt', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    host: '74.80.190.17',
                    username: 'sabhay',
                    secret: 'abcdefgh567635@#%!&',
                    "port": 8000
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            console.log("Interrupted Code Execution");
        } catch (error) {
            console.log("Error occured in Interrupt Code Execution");
            console.log(error);
        }
        finally {
            setInterruptSignalState(prev => {
                sleep(1500);
                // console.log("setting interrupt API state ", prev)
                return true;
            });
            setCellExecutionDetails(prevDetails => {
                const tempDetails = prevDetails.map(cellDetail => {
                    return {
                        ...cellDetail,
                        isExecuting: false
                    };
                });
                return tempDetails;
            });
            controller1.abort();
        }

    }


    const RunCodeCell = async (cellIndex, code, countflag) => {
        try {
            let flagToInterruptStream = false;
            const output = [];
            setResponseData(cellIndex, output);
            // API call
            const response = await fetch('https://workable-ai-ml-2.onrender.com/run-code', {
                signal: controller1.signal,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code: code,
                    host: '74.80.190.17',
                    username: 'sabhay',
                    secret: 'abcdefgh567635@#%!&',
                    "port": 8000
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let partialChunk = '';
            while (true) {
                setInterruptSignalState(prev => {
                    if (prev) flagToInterruptStream = true;
                    return prev;
                });
                if (flagToInterruptStream) {
                    console.log("RunCode Streamer Interrupted!")
                    break;
                }
                const { value, done } = await reader.read();
                if (done) {
                    console.log("done")
                    // setLoading(false);
                    break;
                }
                let decodedChunk = decoder.decode(value, { stream: true });
                let decodedChunkArray = (partialChunk + decodedChunk).split("\n"); // Split by newline characters
                partialChunk = decodedChunkArray.pop(); // Keep the last chunk if it's incomplete JSON
                let decodedChunkJson = {}
                try {
                    for (let i = 0; i < decodedChunkArray.length; i++) {
                        if (decodedChunkArray[i] === "") continue;
                        decodedChunkJson = JSON.parse(JSON.parse(decodedChunkArray[i]));
                        // console.log(decodedChunkJson);
                        if (decodedChunkJson["type"] === "text/plain") {
                            if (decodedChunkJson["name"] === "stderr") {
                                const len = output.length;
                                if (len > 0 && "name" in output[len - 1] && output[len - 1].name === "stderr") {
                                    output.pop();
                                }
                            }
                            output.push({
                                "name": decodedChunkJson["name"],
                                "output_type": "stream",
                                "text": [decodedChunkJson['data']]
                            })
                        }
                        else if (decodedChunkJson["type"] === "traceback") {
                            output.push({
                                "ename": "SyntaxError",
                                "evalue": "invalid syntax (<ipython-input-1-eea3320642ac>, line 1)",
                                "output_type": "error",
                                "traceback": [decodedChunkJson['data']]
                            })
                        }
                        else if (decodedChunkJson["type"] === "image/png") {
                            output.push({
                                "data": {
                                    "image/png": decodedChunkJson['data'],
                                    "text/plain": [
                                        ""
                                    ]
                                },
                                "metadata": {},
                                "output_type": "display_data"
                            },)
                        }
                        else if (decodedChunkJson["type"] === "text/html") {
                            let tempdata = decodedChunkJson['data'].split("\n").map((line, index, array) => index === array.length - 1 ? line : line + '\n')
                            tempdata = tempdata.filter(item => !item.includes("  \n"));
                            output.push({
                                "data": {
                                    "text/html": tempdata,
                                    "text/plain": [
                                        ""
                                    ]
                                },
                                "metadata": {},
                                "output_type": "display_data",
                            })
                        }
                        else {
                            output.push({
                                "name": "stderr",
                                "output_type": "stream",
                                "text": [decodedChunkJson]
                            })
                        }
                    }
                    setResponseData(cellIndex, output);
                } catch (error) {
                    console.log("JSON parse error")
                    console.log(error)
                    output.push({
                        "name": "stderr",
                        "output_type": "stream",
                        "text": ["Internal Server Error"]
                    })
                    setResponseData(cellIndex, output);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCellExecutionDetails(prevDetails => {
                const tempDetails = [...prevDetails];
                tempDetails[cellIndex] = {
                    ...tempDetails[cellIndex],
                    isExecuting: false,
                    executionCount: countflag,
                };
                return tempDetails;
            });
            setInterruptSignalState(prev => {
                // console.log("setting state ", prev)
                return false;
            })
        }

    }

    // Function to add a request to the queue
    const addToQueue = (request) => {
        setRunCodequeue(prevQueue => [...prevQueue, request]);
    };

    // Function to process the queue
    const processQueue = async () => {
        if (RunCodequeue.length > 0 && !processing) {
            setProcessing(true);
            const nextRequest = RunCodequeue[0];
            try {
                await RunCodeCell(nextRequest.cellIndex, nextRequest.code, executionCount);
                setExecutionCount(prev => {
                    return prev + 1;
                })
            } catch (error) {
                console.error('Error processing request:', error);
            } finally {
                setProcessing(false);
                setRunCodequeue(prevQueue => prevQueue.slice(1)); // Remove the processed request from the queue
            }
        }
    };

    // Effect to automatically process the queue whenever it changes
    useEffect(() => {
        processQueue();
    }, [RunCodequeue]);


    const RunCode = React.useCallback((index, code) => {
        setCellExecutionDetails(prevDetails => {
            const tempDetails = [...prevDetails];
            tempDetails[index] = {
                ...tempDetails[index],
                isExecuting: true
            };
            return tempDetails;
        });
        addToQueue({ cellIndex: index, code: code });
    }, [])
    const StopExecution = React.useCallback(() => {
        setRunCodequeue([]);
        InterruptCodeExecution();
    }, []);


    useEffect(() => {
        setRawIpynb(rawIpynb1);
        setCellExecutionDetails(initializeCellExecutionDetailsArray(rawIpynb1));
    }, [rawIpynb1]);
    return (
        <JupyterNotebookComp
            rawIpynb1={rawIpynb}
            originalRawIpynb={rawIpynb1}
            setRawIpynb1={setRawIpynb}
            reRenderNotebook={reRenderNotebook}
            RunCodeCell={RunCode}
            cellExecutionDetails={cellExecutionDetails}
            StopExecution={StopExecution}
        />
    )
}

export default RunNotebook;